import { useMutation } from '@tanstack/react-query';
import { fetchData } from 'utils';
import useError from 'hooks/useError';
import useSmartlook from 'hooks/useSmartlook';

function useConfirmApplicationMutation() {
  const { showError } = useError();
  const { error } = useSmartlook();
  return useMutation<ApplicationConfirmationResponse, unknown, void>({
    mutationFn: async () => {
      try {
        const resp = await fetchData('/client/application', {
          method: 'put',
        });

        return resp;
      } catch (e) {
        error('[useConfirmApplicationMutation][PUT /client/application]', e);
        showError();
        throw e;
      }
    },
  });
}

type ApplicationConfirmationResponse = {
  status: 'IN_PROGRESS';
};

export default useConfirmApplicationMutation;
